import { render, staticRenderFns } from "./AddAcademicMonitor.vue?vue&type=template&id=ca7f1adc&scoped=true"
import script from "./AddAcademicMonitor.vue?vue&type=script&lang=js"
export * from "./AddAcademicMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7f1adc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
